import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Parallax.scss';

class Parallax extends Component {
  state = {
    offsetTop: 0,
  };

  componentDidMount = () => {
    this.animate();
  };

  setTopOffset = (image, container) => {
    const imageHeight = image.offsetHeight;
    const containerHeight = container.offsetHeight;
    const pageHeight = document.documentElement.clientHeight;
    const imageDistance = imageHeight - containerHeight;
    const containerTop = container.getBoundingClientRect().top;

    let distancePercent = 0;
    let offsetTop = 0;

    if (containerTop >= pageHeight) {
      distancePercent = 0;
    } else if (containerTop <= -containerHeight) {
      distancePercent = 1;
    } else {
      distancePercent =
        (containerTop + containerHeight) / (pageHeight + containerHeight);
    }

    offsetTop = distancePercent * imageDistance * -1;

    this.setState({
      offsetTop,
    });
  };

  // reference: https://codepen.io/smonn/pen/WrvBdO?editors=1111
  animate = () => {
    const { parallaxImage, parallaxContainer, animate } = this;

    if (parallaxImage) {
      requestAnimationFrame(animate);

      this.setTopOffset(parallaxImage, parallaxContainer);
    }
  };

  render() {
    const { image, imageStyle } = this.props;

    const { offsetTop } = this.state;

    return (
      <div
        className={styles.root}
        ref={parallaxContainer => {
          this.parallaxContainer = parallaxContainer;
        }}
      >
        {this.props.children || ''}
        <img
          className={styles.image}
          ref={parallaxImage => {
            this.parallaxImage = parallaxImage;
          }}
          style={{
            display: 'block',
            transform: `translate3d(0, ${offsetTop}px, 0)`,
            ...imageStyle,
          }}
          src={image}
        />
      </div>
    );
  }
}

Parallax.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node,
  imageStyle: PropTypes.object,
};

Parallax.defaultProps = {
  children: null,
  imageStyle: {},
};

export default Parallax;



// WEBPACK FOOTER //
// ./app/components/Parallax/Parallax.jsx